import { render } from "./ComebackOffersTable.vue?vue&type=template&id=dee51be2&scoped=true"
import script from "./ComebackOffersTable.vue?vue&type=script&lang=js"
export * from "./ComebackOffersTable.vue?vue&type=script&lang=js"

import "./ComebackOffersTable.vue?vue&type=style&index=0&id=dee51be2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee51be2"]])

export default __exports__